export const useOnConnectionStart = () => {
  return (connection, jobId, setCurrentProgress) => {
    connection.on('UpdateJobProgress', (data) => {
      if (data.jobId == jobId) {
        setCurrentProgress(data.progress);
      }
    });
  };
};
